<div class="engi-button {{ classes }}" [ngClass]="{'a-button-disabled': disabled}">
  <button type="button" class="a-button a-button-choose" (click)="execCallback()" [disabled]="disabled">
    <ng-template [ngIf]="animatedEvent !== undefined" [ngIfElse]="static">
      <span class="message-section"
        [@triggerClickButton]="stateClick"
        (@triggerClickButton.done)="onAnimationDoneEvent($event)">
        <span class="standard-message">{{ translate ? (text | translate) : text }}</span>
        <span class="transition-message {{ animatedIcon }}">{{ translate ? (animatedText | translate) : animatedText }}</span>
      </span>
    </ng-template>
    <ng-template #static>
      {{ translate ? (text | translate) : text }}
    </ng-template>
  </button>
  <v-spinner *ngIf="processing" [activeSpinner]="processing"></v-spinner>
</div>
